import { CapacitorSQLite, SQLiteConnection } from "@capacitor-community/sqlite"

// single shared connection manager — SQLiteConnection keeps track of open connections internally,
// so every part of the app has to use the same instance
export const sqlite = new SQLiteConnection(CapacitorSQLite)
